import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import {
  MdCheckCircle,
  MdRadioButtonChecked,
  MdRadioButtonUnchecked,
} from 'react-icons/md';

export const StepItem = ({ label, active, ongoing, onClick }) => {
  const handleSelect = (e) => {
    e.preventDefault();
    if (typeof onClick === 'function') onClick();
  };
  const renderIcon = React.useMemo(() => {
    if (active) return <MdCheckCircle className="h-8 w-8 text-secondary-800" />;
    if (ongoing)
      return <MdRadioButtonChecked className="h-8 w-8 text-secondary-800" />;
    return <MdRadioButtonUnchecked className="h-8 w-8 text-gray-500" />;
  }, [active, ongoing]);
  return (
    <li className="relative overflow-hidden lg:flex-1">
      <div className="border border-gray-200 overflow-hidden border-b-0 rounded-t-md  lg:border-0">
        {/* {!last ? (
          <span
            className={cn(
              'absolute top-4 left-4 -ml-px h-full w-0.5',
              active ? 'bg-green-600' : 'bg-gray-200'
            )}
            aria-hidden="true"
          />
        ) : null} */}
        <div className="relative flex space-x-3 px-5 py-4 lg:px-0 ">
          <div className="rounded-full bg-gray-100 h-8 w-8">{renderIcon}</div>
          <div className="min-w-0 flex-1 pt-1.5 flex justify-between space-x-4">
            <div>
              <a
                href="/"
                onClick={handleSelect}
                className={cn(onClick ? '' : 'cursor-default')}
              >
                <p
                  className={cn(
                    'font-semibold',
                    ongoing || active ? 'text-secondary-800' : 'text-gray-600'
                  )}
                >
                  {label}
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </li>
  );
};

StepItem.defaultProps = {
  ongoing: false,
  active: false,
  onClick: false,
};

StepItem.propTypes = {
  label: PropTypes.string.isRequired,
  onClick: PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
  ongoing: PropTypes.bool,
  active: PropTypes.bool,
};

function OnboardingSteps({ children, step, description }) {
  return (
    <div className="flex flex-col">
      <ul className="rounded-md overflow-hidden lg:flex lg:rounded-none">
        {children}
      </ul>
      {description[step] && (
        <div className="flex justify-center overflow-hidden pb-5 rounded-md border border-gray-200 border-b-0 lg:rounded-none   lg:border-0">
          <p className="text-base text-gray-500">{description[step]}</p>
        </div>
      )}
    </div>
  );
}

OnboardingSteps.defaultProps = {};

OnboardingSteps.propTypes = {
  step: PropTypes.number.isRequired,
  description: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
};

export default OnboardingSteps;
